import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import FaEnvelope from "react-icons/fa/envelope";
import { Link } from "react-router";
import { isValidValue } from "utils/validators";

export const EnvelopeUploadedCellFormatter = ({ value }) => {
  if (!isValidValue(value)) {
    return <span>Not uploaded yet</span>;
  }
  return <span title={ moment(value).fromNow() }>{ moment(value).format("D MMMM YYYY") }</span>;
};

EnvelopeUploadedCellFormatter.defaultProps = {
  value: ""
};

EnvelopeUploadedCellFormatter.propTypes = {
  value: PropTypes.string
};

export const ReceivedCellFormatter = ({ value }) => {
  if (value === "") {
    return <span>Not received yet</span>;
  }
  return <span title={ moment(value).fromNow() }>{ moment(value).format("D MMMM YYYY") }</span>;
};

ReceivedCellFormatter.defaultProps = EnvelopeUploadedCellFormatter.defaultProps;
ReceivedCellFormatter.propTypes = EnvelopeUploadedCellFormatter.propTypes;

export const SentCellFormatter = ({ value }) => {
  if (!isValidValue(value)) {
    return <span>Not sent yet</span>;
  }
  return <span title={ moment(value).fromNow() }>{ moment(value).format("D MMMM YYYY") }</span>;
};

SentCellFormatter.defaultProps = EnvelopeUploadedCellFormatter.defaultProps;
SentCellFormatter.propTypes = EnvelopeUploadedCellFormatter.propTypes;

export const StatusCellFormatter = ({ value }) => <span>{ value.toUpperCase() }</span>;

StatusCellFormatter.defaultProps = EnvelopeUploadedCellFormatter.defaultProps;
StatusCellFormatter.propTypes = EnvelopeUploadedCellFormatter.propTypes;

export const EnvelopeCellFormatter = ({ isLinkable, onAddEnvelope, onSetFlashMessage, slug, value }) => {
  if (isLinkable) {
    return (
      <span>
        <Link
          onClick={ () => {
            onAddEnvelope(value);
            onSetFlashMessage(`Filtering documents by envelope ${value}`);
          } }
          to={ `/accounts/${slug}/documents/all` }
        >
          { value }
        </Link>
      </span>
    );
  }
  return <span>{ value }</span>;
};

EnvelopeCellFormatter.propTypes = {
  isLinkable: PropTypes.bool.isRequired,
  onAddEnvelope: PropTypes.func.isRequired,
  onSetFlashMessage: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

export const BillableCellFormatter = ({ value }) => {
  if (value) {
    return <FaEnvelope size={ 15 } />;
  }
  return null;
};

BillableCellFormatter.propTypes = {
  value: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/envelopes-grid-cell-formatters.jsx